export const ADD_ACCOUNT_TRANSACTION_CLIENT = "ADD_ACCOUNT_TRANSACTION_CLIENT";
export const ADD_ACCOUNT_TRANSACTION_CLIENT_SUCCESS = "ADD_ACCOUNT_TRANSACTION_CLIENT_SUCCESS";
export const ADD_ACCOUNT_TRANSACTION_CLIENT_FAIL = "ADD_ACCOUNT_TRANSACTION_CLIENT_FAIL";

export const DELETE_ACCOUNT_TRANSACTION_CLIENT = "DELETE_ACCOUNT_TRANSACTION_CLIENT";
export const DELETE_ACCOUNT_TRANSACTION_CLIENT_SUCCESS = "DELETE_ACCOUNT_TRANSACTION_CLIENT_SUCCESS";
export const DELETE_ACCOUNT_TRANSACTION_CLIENT_FAIL = "DELETE_ACCOUNT_TRANSACTION_CLIENT_FAIL";

export const APPROVE_ACCOUNT_TRANSACTION_CLIENT = "APPROVE_ACCOUNT_TRANSACTION_CLIENT";
export const APPROVE_ACCOUNT_TRANSACTION_CLIENT_SUCCESS = "APPROVE_ACCOUNT_TRANSACTION_CLIENT_SUCCESS";
export const APPROVE_ACCOUNT_TRANSACTION_CLIENT_FAIL = "APPROVE_ACCOUNT_TRANSACTION_CLIENT_FAIL";

export const ADD_ACCOUNT_TRANSACTION_CLIENT_BANK = "ADD_ACCOUNT_TRANSACTION_CLIENT_BANK";
export const ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_SUCCESS = "ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_SUCCESS";
export const ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_FAIL = "ADD_ACCOUNT_TRANSACTION_CLIENT_BANK_FAIL";

export const ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT = "ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT";
export const ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_SUCCESS = "ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_SUCCESS";
export const ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_FAIL = "ADD_BY_EXCEL_ACCOUNT_TRANSACTION_CLIENT_FAIL";
